export const partnerRuleErrorCodeMap = {
  notPartnerRefer: {
    code: '380001',
    tracking: 'without partner referral',
    reason: '',
  },
  soldToCountry: {
    code: '380002',
    tracking: 'country',
    reason: '',
  },
  ipLocationCountry: {
    code: '380003',
    tracking: 'country',
    reason: '',
  },
  accountType: {
    code: '380004',
    tracking: 'accountType',
    reason: '',
  },
  promotionPlanMatch: {
    code: '380005',
    tracking: 'selected plan does not match promotion',
    reason: '',
  },
  promotionCouponMatch: {
    code: '380006',
    tracking: 'input coupon does not match promotion coupon',
    reason: '',
  },
  promotionBindCouponValidFail: {
    code: '380007',
    tracking: 'partner coupon validate fail',
    reason: '',
  },
}

export const messageRuleCodeMap = {
  accountType: 'eligibleAccountType',
  country: 'eligibleCountry',
  planList: 'eligiblePlanList',
}
